export type SuitabilityTestPT = {
	id?: number;
	idContract: number;
	idInvestorTestFiller?: number;
	dateOfCompletion?: string | null;
	marketFollowFrequency: number | null;
	educationLevel: number | null;
	financialProfession: number | null;
	financialServicesUsage: number | null;
	depositsHasTraded: boolean | null;
	depositsFrequencyBand: number | null;
	depositsAmountBand: number | null;
	moneyMarketFundsHasTraded: boolean | null;
	moneyMarketFundsFrequencyBand: number | null;
	moneyMarketFundsAmountBand: number | null;
	bondsHasTraded: boolean | null;
	bondsFrequencyBand: number | null;
	bondsAmountBand: number | null;
	sharesHasTraded: boolean | null;
	sharesFrequencyBand: number | null;
	sharesAmountBand: number | null;
	realEstateFundsHasTraded: boolean | null;
	realEstateFundsFrequencyBand: number | null;
	realEstateFundsAmountBand: number | null;
	ventureCapitalFundsHasTraded: boolean | null;
	ventureCapitalFundsFrequencyBand: number | null;
	ventureCapitalFundsAmountBand: number | null;
	pensionFundsHasTraded: boolean | null;
	pensionFundsFrequencyBand: number | null;
	pensionFundsAmountBand: number | null;
	financialInsuranceHasTraded: boolean | null;
	financialInsuranceFrequencyBand: number | null;
	financialInsuranceAmountBand: number | null;
	complexProductsHasTraded: boolean | null;
	complexProductsFrequencyBand: number | null;
	complexProductsAmountBand: number | null;
	knowledgeQ1: number | null;
	knowledgeQ2: number | null;
	knowledgeQ3: number | null;
	knowledgeQ4: number | null;
	knowledgeQ5: number | null;
	knowledgeQ6: number | null;
	knowledgeQ7: number | null;
	knowledgeQ8: number | null;
	knowledgeQ9: number | null;
	knowledgeQ10: number | null;
	suitable?: boolean | null;
	[key: string]: any;
};

export const emptySuitabilityTestPT: SuitabilityTestPT = {
	idContract: 0,
	dateOfCompletion: null,
	marketFollowFrequency: null,
	educationLevel: null,
	financialProfession: null,
	financialServicesUsage: null,
	depositsHasTraded: null,
	depositsFrequencyBand: null,
	depositsAmountBand: null,
	moneyMarketFundsHasTraded: null,
	moneyMarketFundsFrequencyBand: null,
	moneyMarketFundsAmountBand: null,
	bondsHasTraded: null,
	bondsFrequencyBand: null,
	bondsAmountBand: null,
	sharesHasTraded: null,
	sharesFrequencyBand: null,
	sharesAmountBand: null,
	realEstateFundsHasTraded: null,
	realEstateFundsFrequencyBand: null,
	realEstateFundsAmountBand: null,
	ventureCapitalFundsHasTraded: null,
	ventureCapitalFundsFrequencyBand: null,
	ventureCapitalFundsAmountBand: null,
	pensionFundsHasTraded: null,
	pensionFundsFrequencyBand: null,
	pensionFundsAmountBand: null,
	financialInsuranceHasTraded: null,
	financialInsuranceFrequencyBand: null,
	financialInsuranceAmountBand: null,
	complexProductsHasTraded: null,
	complexProductsFrequencyBand: null,
	complexProductsAmountBand: null,
	knowledgeQ1: null,
	knowledgeQ2: null,
	knowledgeQ3: null,
	knowledgeQ4: null,
	knowledgeQ5: null,
	knowledgeQ6: null,
	knowledgeQ7: null,
	knowledgeQ8: null,
	knowledgeQ9: null,
	knowledgeQ10: null,
};
